@for (dot of dots(); track $index) {
  <i class="text-xs" [class]="dot"></i>
}
